import { FC, ReactNode } from 'react'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { Props as ButtonProps } from 'shared/ui/button'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

interface InsuranceLayoutProps {
  title: string
  children: ReactNode
  footer?: Omit<ButtonProps, 'children' | 'slot'> & {
    children: ReactNode
    slot?: ReactNode
  }
  onGoBack: () => void
}

export const InsuranceLayout: FC<InsuranceLayoutProps> = ({
  title,
  children,
  footer,
  onGoBack,
}) => (
  <div className={s.page}>
    <HeaderGoBack
      buttonWhite
      title={title}
      variant="grey"
      isFixed={false}
      onGoBack={onGoBack}
    />

    <main className={s.content}>{children}</main>

    {footer && <ButtonContinue {...footer} />}
  </div>
)
